module.exports = __webpack_public_path__ + "img/blackwhite_badge_supermin4.7f5f0b83.png";